import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { API } from '../config';
import TinyWinsArchitect from './TinyWinsArchitect';

const ArchitectPage = () => {
  const [hasJourney, setHasJourney] = useState(null);
  const [journey, setJourney] = useState(null);
  const [loading, setLoading] = useState(true);
  const [mode, setMode] = useState('normal');
  const [identityContext, setIdentityContext] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Check if coming from SmartAssessment or JourneyReview
    const state = location.state;
    if (state?.fromAssessment) {
      setIdentityContext({
        identityStatement: state.identityStatement,
        habitAction: state.habitAction,
        duration: state.duration
      });
      setMode('normal');
    } else if (state?.fromGraduation) {
      setIdentityContext({
        identityStatement: state.identityStatement,
        currentHabit: state.currentHabit
      });
      setMode(state.mode || 'evolve');
    }
    
    checkJourney();
  }, [location]);

  const checkJourney = async () => {
    try {
      const res = await axios.get(`${API}/journey`);
      setHasJourney(res.data.has_active_journey);
      setJourney(res.data.journey);
      
      // If coming from assessment, don't redirect even if has journey
      const state = location.state;
      if (state?.fromAssessment || state?.fromGraduation) {
        setLoading(false);
        return;
      }
      
      // If user already has an active journey and not from special flow, redirect to dashboard
      if (res.data.has_active_journey) {
        navigate('/dashboard', { replace: true });
        return;
      }
      
      setLoading(false);
    } catch (err) {
      navigate('/', { replace: true });
    }
  };

  const handleComplete = () => {
    navigate('/dashboard');
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-emerald-600"></div>
      </div>
    );
  }

  return (
    <TinyWinsArchitect
      mode={mode}
      currentJourney={journey}
      identityContext={identityContext}
      onComplete={handleComplete}
      onCancel={() => navigate('/dashboard')}
    />
  );
};

export default ArchitectPage;
